export default {
  BASE_URL: '',
  api: [
    {
      name: 'subSign',
      method: 'POST',
      desc: '保存提交签收单',
      path: '/tmb/order/subSign'
    },
    {
      name: 'signDel',
      method: 'GET',
      desc: '保存提交签收单',
      path: '/tmb/order/signDel'
    },
    {
      name: 'rollbackReason',
      method: 'GET',
      desc: '签收单回退原因',
      path: '/order/sign/rollbackReason'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/me-center/order.js